import { render } from "./MainAboutUs.vue?vue&type=template&id=d96b5bf6&scoped=true"
import script from "./MainAboutUs.vue?vue&type=script&lang=js"
export * from "./MainAboutUs.vue?vue&type=script&lang=js"

import "./MainAboutUs.vue?vue&type=style&index=0&id=d96b5bf6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d96b5bf6"]])

export default __exports__